import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'terms-of-service',
    templateUrl: 'src/app/auth/templates/terms-of-service.html',
    standalone: false
})
export class TermsOfServiceComponent {
    captions: any;

    constructor(
        @Inject(ActivatedRoute) private actRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.actRoute.data.subscribe(data => {
            this.captions = data.captions;
        });
    }
}
